(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dose-volume-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  function calculate(vial, liquid, dose, doseUnit, capacity, graduation) {
    if (![vial, liquid, dose, capacity, graduation].every(value => Number.isFinite(value) && value > 0)) return { error: 'invalid' };
    if (!['mg', 'mcg'].includes(doseUnit)) return { error: 'invalid' };
    const doseMg = doseUnit === 'mcg' ? dose / 1000 : dose;
    const concentration = vial / liquid;
    const volume = doseMg / concentration;
    const units = volume * 100;
    if (![doseMg, concentration, volume, units].every(value => Number.isFinite(value) && value > 0)) return { error: 'invalid' };
    if (doseMg > vial * (1 + 1e-12)) return { error: 'exceedsVial' };
    if (volume > capacity * (1 + 1e-12)) return { error: 'exceedsSyringe' };
    const steps = units / graduation;
    const precision = Math.abs(steps - Math.round(steps)) > 1e-9;
    return { concentration, volume, units, position: Math.min(100, volume / capacity * 100), precision };
  }
  if (customElements.get('dose-volume-calculator')) return;
  class DoseVolumeCalculator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('reset', () => setTimeout(() => this.update(), 0));
      this.update();
    }
    format(value) {
      if (value === 0) return '0';
      return value < 0.000001 ? value.toExponential(4) : new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumSignificantDigits: 10 }).format(value);
    }
    update() {
      const fields = this.form.elements;
      const alert = this.querySelector('.dc-alert');
      const empty = this.querySelector('.dc-empty');
      const values = this.querySelector('.dc-values');
      const svg = this.querySelector('.dc-syringe');
      svg.setAttribute('viewBox', '0 0 440 148');
      svg.setAttribute('aria-label', svg.dataset.emptyLabel);
      const liquidVisual = this.querySelector('.dc-liquid');
      const plunger = this.querySelector('.dc-plunger');
      liquidVisual.setAttribute('width', '0');
      plunger.setAttribute('transform', 'translate(0 0)');
      const ticks = this.querySelector('.dc-svg-ticks');
      const labels = this.querySelector('.dc-svg-labels');
      ticks.replaceChildren();
      labels.replaceChildren();
      const maximum = Number(fields.capacity.value) * 100;
      const graduation = Number(fields.graduation.value);
      const labelStep = maximum === 30 ? 5 : maximum === 50 ? 10 : 20;
      const ns = 'http://www.w3.org/2000/svg';
      for (let unit = 0; unit <= maximum; unit += graduation) {
        const x = 92 + unit / maximum * 264;
        const tick = document.createElementNS(ns, 'line');
        tick.setAttribute('x1', String(x));
        tick.setAttribute('x2', String(x));
        tick.setAttribute('y1', '46');
        tick.setAttribute('y2', unit % labelStep === 0 ? '64' : '56');
        ticks.append(tick);
      }
      for (let unit = 0; unit <= maximum; unit += labelStep) {
        const text = document.createElementNS(ns, 'text');
        text.setAttribute('x', String(92 + unit / maximum * 264));
        text.setAttribute('y', '131');
        text.textContent = this.format(unit);
        labels.append(text);
      }
      values.hidden = true;
      alert.hidden = true;
      alert.textContent = '';
      empty.hidden = false;
      if (['vial', 'liquid', 'dose'].some(key => fields[key].value === '')) return;
      const result = calculate(Number(fields.vial.value), Number(fields.liquid.value), Number(fields.dose.value), fields.doseUnit.value, Number(fields.capacity.value), Number(fields.graduation.value));
      empty.hidden = true;
      if (result.error) {
        alert.textContent = this.dataset[result.error];
        alert.hidden = false;
        return;
      }
      values.hidden = false;
      this.querySelector('[data-volume]').textContent = this.format(result.volume);
      this.querySelector('[data-units]').textContent = this.format(result.units);
      this.querySelector('[data-concentration]').textContent = this.format(result.concentration);
      const draw = result.position / 100 * 264;
      svg.setAttribute('viewBox', '0 0 ' + Math.max(440, draw + 430) + ' 148');
      liquidVisual.setAttribute('width', String(draw));
      plunger.setAttribute('transform', 'translate(' + draw + ' 0)');
      svg.setAttribute('aria-label', svg.dataset.graphicLabel + ': ' + this.format(result.units) + ' ' + svg.dataset.unitsLabel);
      if (result.precision) {
        alert.textContent = this.dataset.precision;
        alert.hidden = false;
      }
    }
  }
  customElements.define('dose-volume-calculator', DoseVolumeCalculator);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
